module.exports = __webpack_public_path__ + "static/media/manual.25797071.md";